import Vue from 'vue';
import store from './store';
import router from './routes';
import App from './App.vue';
import Vuex from 'vuex';
import './components';
import './directives';
import './filters';
import './logncrash';
import './api';
import i18nMsg from './const/i18n';
import VueI18n from 'vue-i18n';
import VueMeta from 'vue-meta';
import {VNode} from 'vue';


window.$ = $;

Vue.use(VueI18n);
Vue.use(VueMeta);

export const i18n = new VueI18n({
  locale: 'kr', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: i18nMsg
  // silentTranslationWarn: true  // console창에 [vue-i18n] warn로그 표시 되는 부분 비표시 시키는 설정
});

// Vue.prototype.$eventBus = new Vue()
const eventBus: Vue = new Vue();

Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get: function(): Vue {
      return eventBus;
    }
  }
});

Vue.config.productionTip = false;
Vue.use(Vuex);

const vue = new Vue({
  i18n,
  store,
  router,
  render: (h): VNode => h(App)
}).$mount('#app');

export default vue;
